import { render, staticRenderFns } from "./WorkflowControlsLimit.vue?vue&type=template&id=788ca45e"
import script from "./WorkflowControlsLimit.vue?vue&type=script&lang=js"
export * from "./WorkflowControlsLimit.vue?vue&type=script&lang=js"
import style0 from "./WorkflowControlsLimit.vue?vue&type=style&index=0&id=788ca45e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports